import React from 'react';

import type { PromoWarning, VoucherWarning } from '~/services/PromoService';

import ResolutionGuidance from './ResolutionGuidance';

export type PromoWarningResolution = NonNullable<PromoWarning['resolution'] | VoucherWarning['resolution']>;

export type PromoResolutionTarget =
  | { label: string; href: string }
  | { label: string; onResolve: (resolution: PromoWarningResolution) => void | Promise<unknown>; disabled?: boolean };

export type PromoResolutionTargets = Partial<Record<PromoWarningResolution['key'], PromoResolutionTarget>>;

interface Props {
  resolution?: PromoWarningResolution;
  /** Callers own navigation, field highlighting, and mutations for their current promo or voucher. */
  targets?: PromoResolutionTargets;
}

export default function PromoResolution({ resolution, targets }: Props) {
  if (!resolution) return null;

  return <ResolutionGuidance resolution={resolution} target={targets?.[resolution.key]} />;
}
